import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { API } from "services/API";

export default function Home() {
  const redir = useNavigate();
  const { name } = useParams();

  React.useEffect(() => {
    if (name === undefined) {
      redir("/auth/home");
    } else {
      API.get("userFiles/getUserIdByName.php?name=" + name)
        .then((responseJson) => {
          responseJson = responseJson.data;
          console.log(responseJson);
          console.log(localStorage.getItem("fishuem"));
          if (responseJson.status && responseJson.uid > -1) {
            if (
              localStorage.getItem("fishuem") !== null &&
              localStorage.getItem("fishuid") !== null &&
              localStorage.getItem("fishuimg") !== null &&
              localStorage.getItem("fishuname") !== null
            ) {
              API.interceptors.request.use(function (config) {
                config.headers = {
                  "Content-Type": "multipart/form-data",
                  "X-EncId": localStorage.getItem("fishuid"),
                  "X-EncEm": localStorage.getItem("fishuem"),
                };
                return config;
              });
              redir("/admin/profile/" + responseJson.uid);
            } else {
              redir("/auth/publicprofile/" + responseJson.uid);
            }
          } else {
            redir("/auth/home");
          }
        })
        .catch(() => {
          redir("/auth/home");
        });
    }
  }, [redir, name]);

  return (
    <>
      <div className="text-center">
        <Spinner size="lg" color="primary" />
      </div>
    </>
  );
}
